import utils from "@/shared/utils"
import ApiHelper, { ResponseProps } from "../shared/ApiHelper"
import { categoriaProdutos } from "@/pages/admin/empresa/[id]"

class EventoController {
    async empresas(userId: any) {
        return await ApiHelper.post({
            url: ApiHelper.empresa + '/by-user',
            method: 'POST',
            data: {
                user_id: Number(userId)
            }
        })
    }

    async empresaDoUsuario(userId: any) {
        return await ApiHelper.post({
            url: ApiHelper.empresa + '/usuario',
            method: 'POST',
            data: {
                user_id: userId
            }
        })
    }

    async eventos(empresaId: any, userId: any) {        
        return await ApiHelper.post({
            url: ApiHelper.empresa + '/eventos',
            method: 'POST',
            data: {
                empresa_id: Number(empresaId),
                user_id: Number(userId)
            }
        })
    }

    async all() {
        return await ApiHelper.post({
            url: ApiHelper.eventos,
            method: 'GET'
        })
    }

    async getIngressos(loteId: any, areaId: any, userId: any) {
        return await ApiHelper.post({
            url: ApiHelper.loteIngressos,
            method: 'POST',
            data: {
                area_id: areaId,
                lote_id: loteId,
                user_id: userId
            }
        })
    }

    async getAreaLimiteDisponivel(areaId: number) {
        return await ApiHelper.post({
            url: ApiHelper.areaLimiteDisiponvel,
            method: 'POST',
            data: {
                area_id: areaId
            }
        })
    }

    // Essa função nao é usada
    async addCart(dados: any) {
        return await ApiHelper.post({
            url: ApiHelper.addCart,
            method: 'POST',
            data: dados
        })
    }

    async addItemCart(dados: any) {        
        return await ApiHelper.post({
            url: ApiHelper.api_url + '/eventos/add-item-cart',
            method: 'POST',
            data: dados
        })
    }

    async getCart({ cookie_id, user_id }: any) {
        return await ApiHelper.post({
            url: ApiHelper.getCart,
            method: 'POST',
            data: { cookie_id, user_id }
        })
    }

    async getIngressosCart({ cookie_id, user_id }: any) {
        return await ApiHelper.post({
            url: ApiHelper.getIngressosCart,
            method: 'POST',
            data: { cookie_id, user_id }
        })
    }

    async reservarIngresso({ nome, email, celular, cookie_id }: any) {
        return await ApiHelper.post({
            url: ApiHelper.reservarIngresso,
            method: 'POST',
            data: { nome, email, celular, cookie_id }
        })
    }

    async removeItemCart(ids: number[]) {
        return await ApiHelper.post({
            url: ApiHelper.removeIntCart,
            method: 'POST',
            data: { ids }
        })
    }

    async criarCupom(dados: any) {
        return await ApiHelper.post({
            url: ApiHelper.salvarCupom,
            method: 'POST',
            data: dados
        })
    }

    async deleteCupom(id: number) {
        return await ApiHelper.post({
            url: ApiHelper.deleteCupom,
            method: 'POST',
            data: {
                id
            }
        })
    }

    async getCupons(evento_id: number, inicio?: string, fim?: string) {
        return await ApiHelper.post({
            url: ApiHelper.getCupons,
            method: 'POST',
            data: {
                evento_id, inicio, fim
            }
        })
    }

    async getCupom(cupom: string) {
        return await ApiHelper.post({
            url: ApiHelper.getCupom,
            method: 'POST',
            data: {
                cupom
            }
        })
    }

    async getCupomDetalhes(cupom: string, inicio: string, fim: string, status: string[]) {
        return await ApiHelper.post({
            url: ApiHelper.getCupomDetalhes,
            method: 'POST',
            data: {
                cupom, inicio, fim, status
            }
        })
    }

    async ativarDesativarCupom(id: number, status: boolean) {
        return await ApiHelper.post({
            url: ApiHelper.ativarDesativarCupom,
            method: 'POST',
            data: {
                id, status
            }
        })
    }

    async getProdutosEmpresa(empresa_id: number): Promise<categoriaProdutos[]> {
        var categoriaProdutos: categoriaProdutos[] = []

        const resProdutos = await ApiHelper.post({
            method: 'POST',
            url: ApiHelper.api_url + '/produtos/by-empresa',
            data: {
                empresa_id
            }
        })

        if (resProdutos.response) {
            const groups = utils.groupByFromKey(resProdutos.dados, 'categoria_nome')

            utils.forEachChaveObjeto(groups, (item: string) => {
                var obj: categoriaProdutos = {
                    categoria: item,
                    produtos: groups[item]
                }
                
                categoriaProdutos.push(obj)
            })
        }

        return categoriaProdutos
    }

    async getProdutosEvento(evento_id: number): Promise<categoriaProdutos[]> {
        var categoriaProdutos: categoriaProdutos[] = []

        const resProdutos = await ApiHelper.post({
            method: 'POST',
            url: ApiHelper.eventos + '/get-produtos',
            data: {
                evento_id
            }
        })

        if (resProdutos.response) {
            const groups = utils.groupByFromKey(resProdutos.dados, 'categoria_nome')

            utils.forEachChaveObjeto(groups, (item: string) => {
                var obj: categoriaProdutos = {
                    categoria: item,
                    produtos: groups[item]
                }
                
                categoriaProdutos.push(obj)
            })
        }

        return categoriaProdutos
    }

    async addProduto(evento_id: number, produto_id: number) {
        return await ApiHelper.post({
            url: ApiHelper.eventos + '/add-produto',
            method: 'POST',
            data: {
                evento_id, produto_id
            }
        })
    }

    async deletarProduto(evento_id: number, produto_id: number) {
        return await ApiHelper.post({
            url: ApiHelper.eventos + '/deletar-produto',
            method: 'POST',
            data: {
                evento_id, produto_id
            }
        })
    }
}

export default new EventoController()